import React from "react";
import { connect } from 'react-redux'
import { requestSongbook } from "../../api/songbook-pdf/actions";
import { handleNetworkError } from "../../utils";
import Pusher from 'react-pusher';
import ProgressBar from "../progress-bar";

gettext('Just a second, we\'re preparing your PDF...')
gettext('You can download it here.')
// The generator sends these as Pusher messages; listed here so they are extracted and translated
const gae0 = gettext('Starting PDF generation...')
const gae1 = gettext('Gathering PDF data, this may take some time...')
const gae2 = gettext('Your PDF is ready')
const gae3 = gettext('Generating PDF, round 1')
const gae4 = gettext('Generating PDF, round 2')
const gae5 = gettext('Generating PDF, round 3')
const gae6 = gettext('Generating PDF, round 4')
const gae7 = gettext('Generating PDF, round 5')


class FinishPDF extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            started: false,
            progress: 0,
            round: 0,
            message: null,
            url: null,
            error: false,
        }
        this.updateProgress = this.updateProgress.bind(this)
    }

    componentDidMount(){
        this.props.dispatch(requestSongbook(this.props.songbookPDF))
            .catch((error) => {
                this.setState(state => ({error: !state.url}))
                handleNetworkError(error)
            })
    }

    updateProgress(e) {
        if (e.error) {
            this.setState({error: true})
            return
        }
        // A finished PDF wins over an earlier request error (e.g. our request timed out after the job was queued)
        this.setState({started: true, ...e, error: e.url ? false : this.state.error})
    }

    render() {
        let {id} = this.props.user
        return (
            <div className="text-center">
                <h4 className="subtitle">
                    { this.state.error ?
                        <>{gettext('Something went wrong while creating your PDF. Please try again.')}</>
                    : this.state.started ?
                        <>{this.state.message && gettext(this.state.message)}</>
                        :
                        <>{gettext('Just a second, we\'re preparing your PDF...')}</>
                    }
                </h4>
                { id &&
                    <>
                        <Pusher
                            channel={`user-${id}`}
                            event="songbook_pdf_file_progress"
                            onUpdate={this.updateProgress}
                        />
                        { this.state.started && !this.state.url && !this.state.error &&
                            <ProgressBar completed={this.state.progress} />
                        }
                        { this.state.started && this.state.url && 
                            <a href={this.state.url}>{gettext('You can download it here.')}</a>
                        }
                    </>
                }
            </div>

        )
    }
}

function mapStateToProps(state) {
    var f = {
      dispatch: {},
      songbookPDF: {},
  
    }
    f.dispatch = (state.dispatch === undefined) ? [] : state.dispatch
    f.songbookPDF = (state.songbookPDF === undefined) ? [] : state.songbookPDF
    return f;
  }

  export default connect(mapStateToProps)(FinishPDF);
